<template>
  <button class="uk-button"
    @click="clicked"
    :class="[classes, {
      'tm-button-half': half
    }]"
    :disabled="disabled"
    :type="type"
    :title="disabled ? '' : title"
    :data-uk-tooltip="disabled ? false : '{ delay: 500 }'">
    <i v-if="icon" class="uk-icon-justify uk-icon-{{ icon }}"></i>
    {{ text }}
    <slot></slot>
  </button>
</template>

<script>
import { Button } from 'vuikit'

export default {
  extends: Button,
  props: {
    half: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'mini'
    },
    icon: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    clicked: function () {
      if (this.href) {
        window.open(this.href, '_blank')
      }
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** TmButton.vue?fcea2d8c
 **/